<template>
  <div class="personalReportList">
    <div class="title">
      <div class="mainTitle">
        个人信息报告
        <Guide />
      </div>
      <Btn
        btnText="生成个人信息报告"
        className="default"
        :plus="true"
        :width="165"
        :height="39"
        style="color:#6E6E6E"
        @handleClick="
          $router.push({
            path: '/personal/index',
            query: { isSelect: true }
          })
        "
      />
    </div>
    <PageDescription position="reportList"/>
    <QA position="reportList" :showToggle="true"/>

    <el-table
      empty-text=" "
      v-loading="listLoading"
      :data="list"
      fit
      highlight-current-row
    >
      <el-table-column label="报告名称" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="生成时间" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="100px" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160px" align="center">
        <template slot-scope="scope">
          <span class="detail" @click="handleCredentials(scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <no-data v-if="list.length === 0" top="-260px" />

    <!-- <Cover
      :dialogGuide="dialogGuide"
      @dialogGuideClose="handleDialogGuideClose"
    >
      <ul slot="content">
        <li>
          <div>生成个人信息报告：</div>
          <div>
            您可以从数据档案中勾选必要信息生成个人信息报告，通过电子证书授权他人查看。
          </div>
        </li>
        <li>
          <div>生成电子证书：</div>
          <div>每份报告可生成多个电子证书，授权可查看时间段、可查看次数。</div>
        </li>
        <li>
          <div>下载电子证书：</div>
          <div>
            生成的电子证书可通过下载保存证书或者微信直接分享给他人。
          </div>
        </li>
      </ul>
    </Cover> -->
  </div>
</template>

<script>
import Cover from "@/components/Cover.vue";
import { reportList, etcInfo, etcList } from "@/api/report";
import Btn from "../../../components/Btn.vue";
import NoData from "../../../components/NoData.vue";
import Guide from "../../../components/Guide.vue";
import PageDescription from "../../../components/PageDescription.vue";
import QA from '../../../components/QA.vue';
export default {
  components: { Cover, Btn, NoData, Guide, PageDescription, QA },
  data() {
    return {
      list: [],
      dialogGuide: false,
      listLoading: false,
      listQuery: {
        current: 1,
        pages: 1,
        size: 10
      },
      noDataShow: false
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleDialogGuideClose() {
      this.dialogGuide = !this.dialogGuide;
    },
    handleCredentials(row) {
      this.$router.push("credentialsList");
      localStorage.setItem("report", JSON.stringify(row));
    },
    getList() {
      reportList(this.listQuery).then(res => {
        console.log(res);
        this.list = res.data.d.records;
        this.noDataShow = this.list.length === 0;
      });
      etcList({ reportId: "1546831665269108738" }).then(res => {
        console.log(res);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.personalReportList {
  display: flex;
  margin-top: 39px;
  flex: 1;
  margin-bottom: 70px;
  background: #fff;
  margin-left: 17px;
  padding: 38px 41px 60px 40px;
  flex-direction: column;
  min-height: 702px;
  box-sizing: border-box;
  >>>.el-table th.el-table__cell {
    background-color: #f0f2f5;
  }
  >>>.el-table {
    color: #6e6e6e;
  }
  >>>.cell{
    font-weight: 500;
    color: #6e6e6e;
  }
  .title {
    margin-bottom: 22px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // align-items: center;
    font-size: 20px;

    .mainTitle {
      display: flex;
      align-items: center;
      &::before {
        content: "";
        border-left: 3px solid #3a61b1;
        padding-right: 10px;
        height: 16px;
        position: relative;
        top: 0px;
      }
      // .guide {
      //   font-size: 14px;
      //   font-weight: normal;
      //   color: #6e6e6e;
      //   display: flex;
      //   align-items: center;
      //   .ico_guide {
      //     background: #ff8d65;
      //     width: 15px;
      //     height: 15px;
      //     display: inline-block;
      //     border-radius: 15px;
      //     margin-right: 5px;
      //     margin-left: 12px;
      //     font-style: normal;
      //     text-align: center;
      //     color: #fff;
      //     font-size: 12px;
      //   }
      // }
    }
  }
  .detail {
    color: #338ff7;
    cursor: pointer;
  }
  .btn_default {
    width: 165px;
    height: 39px;
    border: 1px solid #ddd;
    border-radius: 19.5px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/report/list.vue